module.exports = __webpack_public_path__ + "img/employees.1773f936.svg";